import SelectedFilterView from './SelectedFilter.view';

let Backbone = window.Backbone;


export default Backbone.View.extend({
  el: '.js-userContent__selectedFilters',

  events: {

  },

  initialize: function(options){
    this.taxonomy = options.taxonomy;
    this.render();
    this.collection.on('all', this.render, this);
  },

  render: function(){
    this.$el.empty();

    this.collection.each((filter) => {
      this.$el.append( new SelectedFilterView({
        model: filter
      }).$el );
    });

    return this;
  }
});


// WEBPACK FOOTER //
// ./assets/src/javascripts/userContent/filters/SelectedFilters.view.js